export const BANK_NAME = 'Банковский перевод';
export const WALLET_NAME = 'Наличные';
export const WEB_MONEY_NAME = 'Капиталист';
export const WESTERN_UNION_NAME = 'Western Union';
export const CRYPTO_NAME = 'Crypto';

export const EXCHANGE_NAME = 'Биржа';
export const CRYPTO_WALLET_NAME = 'Кошелёк';


